export default "__VITE_ASSET__DjjtuCkC__"